import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { RootContainer, InfoContainer } from './styles';

export function BudgetInfo({ info }) {
  return (
    <RootContainer>
      <InfoContainer>
        <Box>
          <Typography
            sx={{ fontSize: '0.8rem', fontWeight: 800 }}
            variant="body2"
            component="span"
          >
            Total estimado inicial:
          </Typography>
          <Typography
            sx={{ fontSize: '0.8rem' }}
            variant="body2"
            component="span"
          >
            {` ${new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }).format(info?.total_budget || 0)}`}
          </Typography>
        </Box>

        <Box>
          <Typography
            sx={{ fontSize: '0.8rem', fontWeight: 800 }}
            variant="body2"
            component="span"
          >
            Total estimado inicial por M²:
          </Typography>
          <Typography
            sx={{ fontSize: '0.8rem' }}
            variant="body2"
            component="span"
          >
            {` ${new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }).format(info?.total_budget_per_m2 || 0)}`}
          </Typography>
        </Box>
      </InfoContainer>

      <InfoContainer>
        <Box>
          <Typography
            sx={{ fontSize: '0.8rem', fontWeight: 800 }}
            variant="body2"
            component="span"
          >
            Total executado:
          </Typography>
          <Typography
            sx={{ fontSize: '0.8rem' }}
            variant="body2"
            component="span"
          >
            {` ${new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }).format(info?.total_paid || 0)}`}
          </Typography>
        </Box>

        <Box>
          <Typography
            sx={{ fontSize: '0.8rem', fontWeight: 800 }}
            variant="body2"
            component="span"
          >
            Total executado por M²:
          </Typography>
          <Typography
            sx={{ fontSize: '0.8rem' }}
            variant="body2"
            component="span"
          >
            {` ${new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }).format(info?.total_paid_per_m2 || 0)}`}
          </Typography>
        </Box>
      </InfoContainer>

      <InfoContainer>
        <Box>
          <Typography
            sx={{ fontSize: '0.8rem', fontWeight: 800 }}
            variant="body2"
            component="span"
          >
            Total estimado final:
          </Typography>
          <Typography
            sx={{ fontSize: '0.8rem' }}
            variant="body2"
            component="span"
          >
            {` ${new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }).format(info?.total_estimate || 0)}`}
          </Typography>
        </Box>

        <Box>
          <Typography
            sx={{ fontSize: '0.8rem', fontWeight: 800 }}
            variant="body2"
            component="span"
          >
            Total estimado final por M²:
          </Typography>
          <Typography
            sx={{ fontSize: '0.8rem' }}
            variant="body2"
            component="span"
          >
            {` ${new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }).format(info?.total_estimate_per_m2 || 0)}`}
          </Typography>
        </Box>
      </InfoContainer>
    </RootContainer>
  );
}
